'use strict';

const COOKIE_NAME = 'cookie_consent';
const COOKIE_ACCEPTED = 'accepted';
const COOKIE_DECLINED = 'declined';
const COOKIE_EXPIRY_DAYS = 365;

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value)
        + '; expires=' + date.toUTCString()
        + '; path=/; SameSite=Lax';
}

function grantConsent() {
    if (typeof gtag === 'function') {
        gtag('consent', 'update', {
            analytics_storage: 'granted',
            ad_storage: 'granted',
        });
        console.log('analytics consent granted');
    }
}

function revokeConsent() {
    if (typeof gtag === 'function') {
        gtag('consent', 'update', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
        });
        console.log('analytics consent revoked');
    }
}

function hideBanner() {
    const el = document.querySelector('.block_cookie_policy');
    if (el) el.classList.remove('visible');
}

function showBanner() {
    const el = document.querySelector('.block_cookie_policy');
    if (el) el.classList.add('visible');
}

export function init() {
    const consent = getCookie(COOKIE_NAME);

    if (consent === COOKIE_ACCEPTED) {
        hideBanner();
        grantConsent();
    } else if (consent === COOKIE_DECLINED) {
        hideBanner();
    } else {
        showBanner();
    }

    document.addEventListener('click', (event) => {
        const target = event.target.closest(
            '.js-cookie-btn-accept, .js-cookie-btn-decline, .js-cookie-settings'
        );
        if (!target) return;

        event.preventDefault();

        if (target.classList.contains('js-cookie-btn-accept')) {
            setCookie(COOKIE_NAME, COOKIE_ACCEPTED, COOKIE_EXPIRY_DAYS);
            hideBanner();
            grantConsent();
        } else if (target.classList.contains('js-cookie-btn-decline')) {
            setCookie(COOKIE_NAME, COOKIE_DECLINED, COOKIE_EXPIRY_DAYS);
            hideBanner();
            revokeConsent();
        } else if (target.classList.contains('js-cookie-settings')) {
            showBanner();
        }
    });
}
